export default __webpack_public_path__ + "static/media/30-day-pull-up.415e8720.jpeg";